import { useRef, useState, useEffect } from "react";
import "../business.css";
import "../../../components/SearchBar/SearchBar.css";
import { PiTagSimpleThin } from "react-icons/pi";

const BusinessSearchBar = ({
  searchTerm,
  setSearchTerm,
  categories = [],
  services = [],
  onSearchSubmit
}) => {

  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const clearSearch = () => {
    setSearchTerm("");
    setShowDropdown(false);
    onSearchSubmit("");
  };

  const handleSelect = (s) => {
    setSearchTerm(s);
    setShowDropdown(false);
    onSearchSubmit(s);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSearchSubmit(searchTerm);
      setShowDropdown(false);
    }
  };

  const mergedTags = [
    ...categories.map((c) => c.name),
    ...services.map((s) => s.name)
  ];

  const filteredTags = mergedTags.filter((t) =>
    t.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="search-container" id="search-container" ref={wrapperRef}>
      <div className="search-wrapper" id="search-wrapper">

        <input
          className="searchInput"
          type="text"
          placeholder="Ex. Search for Restaurants / Financial Consulting / Electricians / Plumber"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setShowDropdown(true);
          }}
          onKeyDown={handleKeyDown}
        />

        {searchTerm ? (
          <button className="clearBtn" onClick={clearSearch}>
            <img src="/images/close.png" alt="Clear" />
          </button>
        ) : (
          <button
            className="searchBtn"
            onClick={() => onSearchSubmit(searchTerm)}
          >
            <img src="/images/search.png" alt="Search" />
          </button>
        )}
      </div>

      {showDropdown && filteredTags.length > 0 && (
        <div className="search-dropdown">
          {filteredTags.map((tag) => (
            <div
              key={tag}
              className="dropdown-items tag-suggestion"
              onClick={() => handleSelect(tag)}
            >
              <span className="suggested_tags">
                <PiTagSimpleThin /> {tag}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BusinessSearchBar;
